import PropTypes from 'prop-types';
import { DataGrid } from '@celltrak/ui-components';

import { requiredFieldsListHeaders } from '../../constants';
import { getSelectionToClipboard } from '../../../Common/utils';

import useRequiredFieldsList from './hooks';
import styles from './RequiredFieldsList.module.scss';

function RequiredFieldsList({ requiredFieldsReports, loading }) {
  const { handleColumnClick, sortByColumn, sortDirection } = useRequiredFieldsList();

  return (
    <div className={styles.gridContainer} onMouseUp={getSelectionToClipboard} role="none">
      <DataGrid
        rows={requiredFieldsReports}
        headers={requiredFieldsListHeaders}
        fullWidth
        loading={loading}
        onColumnClick={handleColumnClick}
        sortByColumn={sortByColumn}
        sortDirection={sortDirection}
      />
    </div>
  );
}

RequiredFieldsList.propTypes = {
  requiredFieldsReports: PropTypes.arrayOf(
    PropTypes.shape({
      fieldName: PropTypes.string,
      format: PropTypes.string,
    }),
  ),
  loading: PropTypes.bool,
};

RequiredFieldsList.defaultProps = {
  requiredFieldsReports: [],
  loading: false,
};

export default RequiredFieldsList;
